import template from './header.html';
import controller from './header.controller';

let headerComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default headerComponent;




// WEBPACK FOOTER //
// ./client/app/layout/header.component.js